import { render, staticRenderFns } from "./ModalCreateNewReport.vue?vue&type=template&id=1f72ee34&scoped=true"
import script from "./ModalCreateNewReport.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f72ee34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f72ee34')) {
      api.createRecord('1f72ee34', component.options)
    } else {
      api.reload('1f72ee34', component.options)
    }
    module.hot.accept("./ModalCreateNewReport.vue?vue&type=template&id=1f72ee34&scoped=true", function () {
      api.rerender('1f72ee34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalCreateNewReport.vue"
export default component.exports